import '../../_helpers/sort-by.js'
export const listImageCrop = [
    {value:'CENTER', label:'Center'},
    {value:'FACES', label:'Faces'},
    {value:'ENTROPY', label:'Entropy'},
    {value:'LEFT', label:'Left'},
    {value:'RIGHT', label:'Right'},
    {value:'TOP', label:'Top'},
    {value:'BOTTOM', label:'Bottom'},
].sortBy('label')